export default __webpack_public_path__ + "static/testimonialLarge-36f2cd56a0129f65408af7edec5325de.jpg";